import { installNumericInputGuard } from './utils/numericInputGuard';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

installNumericInputGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
